var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('import-upload',{attrs:{"import-type":"contact","path-prefix":"contacts"},on:{"cancel":_vm.onCancel,"upload":_vm.onUpload}})}
var staticRenderFns = []

export { render, staticRenderFns }